<app-base-modal
  [title]="'Группы блогеров'"
  [showStateToggle]="bloggerGroupsStateService.bloggerGroups().length > 0"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="current-blogger-groups">
    @for (bloggerGroup of bloggerGroupsStateService.bloggerGroups(); track $index) {
      <div class="current-blogger-groups-content">
        <mat-form-field
          appearance="outline"
          class="current-blogger-groups-form-field"
          [class.none-pointer-events]="!isEditModeActive"
        >
          <mat-label>Название</mat-label>
          <input
            matInput
            [(ngModel)]="bloggerGroup.name"
            (blur)="handleUpdateName(bloggerGroup)"
          >
        </mat-form-field>
        <button
          mat-icon-button
          tabindex="-1"
          class="current-blogger-groups-btn"
          [matTooltip]="'Удалить'"
          (click)="handleClickDelete(bloggerGroup.id)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    } @empty {
      <div>
        Нет групп
      </div>
    }
  </div>
</app-base-modal>
